// import { API_URL } from '../../config'
import { generatePopup } from '../../utils/popup'
// import axios from 'axios'
import { auth, firestore } from '../../firebase'
import { getFirestore, collection, doc, setDoc, getDocs, getDoc, updateDoc, query, where, Timestamp } from 'firebase/firestore'
// import { rejects } from 'assert'
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { Action } from '../actionTypes';
import { getFunctions, httpsCallable } from 'firebase/functions';



export const getAllUser: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_ALLUSER_INIT,
        })
        const userCollection = collection(firestore, 'users');
        try {

            const querySnapshot = await getDocs(userCollection)
            let users: any[] = [];
  
            querySnapshot.forEach((doc) => {

                const data = doc.data();
                const refid = doc.id;
                
                // Filter out B2B accounts - they should only appear in B2B accounts table
                if (data?.protected?.isB2B) {
                    return; // Skip this user as it's a B2B account
                }
                
                let ref = {...data};
                ref['id'] = refid;
                ref['name'] = ref.firstName + ' ' + ref.lastName;
                ref['type'] = 'standard'
                ref['email'] = ref?.protected?.email;
                ref?.protected?.isAdmin && (ref['type'] = 'administrator');
                ref?.protected?.isBeta && (ref['type'] = 'beta');
                ref?.protected?.isB2b && (ref['type'] = 'B2B');
                ref?.protected?.isEnhanced && (ref['type'] = 'enhanced');
                users.push({ ...ref });
            });
            dispatch({
                type: Action.ADMIN_GET_ALLUSER_SUCCESS,
                payload: users,
            });
            resolve(users);
        } catch (error) {
            dispatch({
                type: Action.ADMIN_GET_ALLUSER_FAIL,
                payload: error,
            });
        }
    });
};

export const getAllReferrals: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_REFERRALS_INIT,
        })
        const userCollection = collection(firestore, 'referrals');
        try {

            const querySnapshot = await getDocs(userCollection)
            let referrals: any[] = [];
  
            querySnapshot.forEach((doc) => {

                const data = doc.data();
                console.log(data);
                const refid = doc.id;
                let ref = {...data};
                ref['id'] = refid;
                ref['name'] = ref.first_name + ' ' + ref.last_name;
                ref['status'] = 'pending';
                if (ref?.notified_at){
                    ref['status'] = 'notified';
                }
                if (ref?.invited_at){
                    ref['status'] = 'invited';
                }
                if (ref?.joined_at){
                    ref['status'] = 'joined';
                }
                referrals.push({ ...ref });
            });
            dispatch({
                type: Action.ADMIN_GET_REFERRALS_SUCCESS,
                payload: referrals,
            });
            resolve(referrals);
        } catch (error) {
            dispatch({
                type: Action.ADMIN_GET_REFERRALS_FAIL,
                payload: error,
            });
        }
    });
};

export const getAllOfferCodes: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_OFFERCODES_INIT,
        })
        const userCollection = collection(firestore, 'offercodes');
        try {

            const querySnapshot = await getDocs(userCollection)
            let offercodes: any[] = [];
  
            querySnapshot.forEach((doc) => {

                const data = doc.data();
                const refid = doc.id;
                let ref = {...data};
                ref['id'] = refid;
                
                // Format data for table display
                // Type - determine if it's subscription, product, or both
                if (ref.subscription_discount > 0 && ref.product_discount > 0) {
                    ref['type'] = 'Subscription + Product';
                } else if (ref.subscription_discount > 0) {
                    ref['type'] = 'Subscription Only';
                } else if (ref.product_discount > 0) {
                    ref['type'] = 'Product Only';
                } else {
                    ref['type'] = 'Trial/Other';
                }
                
                // Redemptions left
                if (ref.max_redemptions > 0) {
                    const remaining = ref.max_redemptions - (ref.redemptionCount || 0);
                    ref['limit'] = remaining > 0 ? remaining : 'Exhausted';
                } else {
                    ref['limit'] = 'Unlimited';
                }
                
                // Format product discount
                if (ref.product_discount > 0) {
                    const suffix = ref.product_discount_is_percent ? '%' : '$';
                    ref['product_discount'] = ref.product_discount + suffix;
                } else {
                    ref['product_discount'] = 'None';
                }
                
                // Format subscription discount
                if (ref.subscription_discount > 0) {
                    const suffix = ref.subscription_discount_is_percent ? '%' : '$';
                    ref['subscription_discount'] = ref.subscription_discount + suffix;
                } else {
                    ref['subscription_discount'] = 'None';
                }
                
                // Days applicable (cycles)
                if (ref.cycles > 0) {
                    ref['length'] = ref.cycles + ' month' + (ref.cycles !== 1 ? 's' : '');
                } else {
                    ref['length'] = 'Forever';
                }
                
                // Expiration
                if (ref.valid_end > 0) {
                    const expDate = new Date(ref.valid_end);
                    ref['expiration'] = expDate.toLocaleDateString();
                } else {
                    ref['expiration'] = 'Never';
                }
                
                // Status (Live)
                ref['status'] = ref.is_live ? 'Yes' : 'No';
                
                // Format allow_in_checkout
                ref['allow_in_checkout'] = ref.allow_in_checkout ? 'Yes' : 'No';
                
                // Add Stripe info for debugging
                ref['stripeCouponId'] = ref.stripeCouponId || 'None';
                
                offercodes.push({ ...ref });
            });
            dispatch({
                type: Action.ADMIN_GET_OFFERCODES_SUCCESS,
                payload: offercodes,
            });
            resolve(offercodes);
        } catch (error) {
            dispatch({
                type: Action.ADMIN_GET_OFFERCODES_FAIL,
                payload: error,
            });
        }
    });
};


export const Userdownloadexcel: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_ALLUSER_DOWNLOAD_INIT
        });

        try {
            const userCollection = collection(firestore, 'users');

            // Query Firestore to get all user data
            const querySnapshot = await getDocs(userCollection);
            const users: any[] = [];

            querySnapshot.forEach((doc) => {
                const userData = doc.data();
                const userId = doc.id;
                
                // Filter out B2B accounts - they should only appear in B2B accounts export
                if (userData?.protected?.isB2B) {
                    return; // Skip this user as it's a B2B account
                }
                
                users.push({ id: userId, ...userData });
            });

            dispatch({
                type: Action.ADMIN_GET_ALLUSER_DOWNLOAD_SUCCESS,
                payload: users,
            });
            resolve(users);
        } catch (error) {
            dispatch({
                type: Action.ADMIN_GET_ALLUSER_DOWNLOAD_FAIL,
                payload: error,
            });
        }
    });
}


export const getUserByid: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        // const uid = localStorage.getItem('userId')
        dispatch({
            type: Action.GET_USERBY_ID_INIT,
        })

        try {
            const userRef = doc(firestore, `users`, payload)
            const userSnap = await getDoc(userRef)
            if (userSnap.exists()) {
                let res = userSnap.data()
                res['_id'] = userSnap.id
                dispatch({
                    type: Action.GET_USERBY_ID_SUCCESS,
                    payload: res,
                })
                resolve(res)
            } else {
                dispatch({
                    type: Action.GET_USERBY_ID_FAIL,
                    payload: 'Failed to get user!',
                })
                generatePopup('error', 'Could not find User.')
            }
        } catch (error: any) {
            dispatch({
                type: Action.GET_USERBY_ID_FAIL,
                payload: 'Failed to get user!',
            })
            generatePopup('error', 'Could not find User.')
        }
    })
}

export const updateUser: any = (payload: any) => async (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            const { userId, updatedData } = payload;
            dispatch({
                type: Action.UPDATE_USER_INIT,
            });

            const db = getFirestore(); // Initialize Firestore

            const userDocRef = doc(db, 'users', userId); // Reference to the user document

            setDoc(userDocRef, updatedData, { merge: true })
                .then(() => {
                    dispatch({
                        type: Action.UPDATE_USER_SUCCESS,
                    });
                    generatePopup('success', 'User updated successfully.');
                    resolve(true);
                })
                .catch((error) => {
                    console.log(`Unsuccessful returned error ${error}`);
                    dispatch({
                        type: Action.UPDATE_USER_FAIL,
                        payload: error.message,
                    });
                    reject(error);
                });
        } catch (error) {
            const typedError = error as Error;
            dispatch({
                type: Action.UPDATE_USER_FAIL,
                payload: typedError.message,
            });
            reject(error);
        }
    })
}

export const deleteUserByid: any = (payload: any) => (dispatch: any) => {
    return new Promise<void>((resolve, reject) => {
        dispatch({
            type: Action.DELETE_USER_INIT,
        })

        // Update the user's status to inactive in Firebase Firestore
        const db = getFirestore()
        const userRef = doc(db, 'users', payload)

        updateDoc(userRef, {
            status: 'inactive',
        })
            .then((res) => {
                dispatch({
                    type: Action.DELETE_USER_SUCCESS,
                })
                generatePopup('success', 'User status updated to inactive.')
                resolve(payload)
            })
            .catch((error) => {
                console.error('Error updating user status:', error)
                reject(error)
            })
    })
}

export const addUser: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.AUTH_REGISTER_INIT,
        });
        try {
            const { email, password, firstName, lastName } = payload;

            // Create the user with email and password
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);

            // Update the user's display name
            await updateProfile(userCredential.user, { displayName: firstName + ' ' + lastName });

            generatePopup("success", "user Add successfully.");
            resolve(payload);
        } catch (error: any) {
            // Check the Firebase error code
            if (error.code === 'auth/email-already-in-use') {
                // Handle the case of invalid email/password
                generatePopup("error", "Email already registered!");
            } else {
                // Handle other Firebase authentication errors
                generatePopup("error", "An error occurred. Please try again later.");
            }

            dispatch({
                type: Action.AUTH_REGISTER_FAIL,
                payload: typeof error === "string" ? error : "User already registered!",
            });
            resolve(error);
        }
    });
}

// Get all B2B accounts
export const getAllB2BAccounts: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_B2B_ACCOUNTS_INIT,
        })
        
        try {
            const userCollection = collection(firestore, 'users');
            const q = query(userCollection, where('protected.isB2B', '==', true));
            const querySnapshot = await getDocs(q);
            
            let b2bAccounts: any[] = [];
  
            querySnapshot.forEach(async (doc) => {
                const data = doc.data();
                const refid = doc.id;
                let userCount = 0;
                try {
                    const invitationsRef = collection(firestore, 'users', refid, 'invitations');
                    const acceptedInvitationsQuery = query(invitationsRef, where('status', '==', 'accepted'));
                    const acceptedInvitationsSnapshot = await getDocs(acceptedInvitationsQuery);
                    userCount = acceptedInvitationsSnapshot.size;
                } catch (err) {
                    userCount = 0;
                }

                let ref = { ...data };
                ref['id'] = refid;
                ref['name'] = ref.businessName;
                ref['type'] = 'B2B';
                ref['email'] = ref?.protected?.email || 'No Email';
                ref['status'] = ref?.protected?.isActive ? 'Active' : 'Inactive';
                ref['created'] = ref?.protected?.created;
                ref['createdBy'] = ref?.protected?.createdBy;
                ref['userCount'] = userCount;
                b2bAccounts.push({ ...ref });
            });
            
            dispatch({
                type: Action.ADMIN_GET_B2B_ACCOUNTS_SUCCESS,
                payload: b2bAccounts,
            });
            resolve(b2bAccounts);
        } catch (error) {
            dispatch({
                type: Action.ADMIN_GET_B2B_ACCOUNTS_FAIL,
                payload: error,
            });
            reject(error);
        }
    });
};

// Create B2B account
export const createB2BAccount: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_CREATE_B2B_ACCOUNT_INIT,
        })
        
        try {
            const adminUserId = localStorage.getItem('userId');
            const { businessName, adminToolsPermission } = payload;
            
            // Generate unique ID for B2B account
            const b2bAccountId = doc(collection(firestore, 'users')).id;
            
            const b2bAccountData = {
                businessName: businessName,
                protected: {
                    createdBy: adminUserId,
                    created: Timestamp.now(),
                    is_verified: true,
                    isAdmin: false,
                    isBeta: false,
                    isB2B: true,
                    isCreator: false,
                    isActive: true,
                    terms: true,
                    adminToolsPermission: adminToolsPermission || false
                }
            };
            
            await setDoc(doc(firestore, 'users', b2bAccountId), b2bAccountData);
            
            dispatch({
                type: Action.ADMIN_CREATE_B2B_ACCOUNT_SUCCESS,
                payload: { ...b2bAccountData, id: b2bAccountId },
            });
            
            // generatePopup('success', 'B2B account created successfully');
            resolve({ ...b2bAccountData, id: b2bAccountId });
        } catch (error: any) {
            dispatch({
                type: Action.ADMIN_CREATE_B2B_ACCOUNT_FAIL,
                payload: error.message,
            });
            generatePopup('error', 'Failed to create B2B account');
            reject(error);
        }
    });
};

// Update B2B account
export const updateB2BAccount: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_UPDATE_B2B_ACCOUNT_INIT,
        })
        
        try {
            const { accountId, updatedData } = payload;
            const accountRef = doc(firestore, 'users', accountId);
            
            await updateDoc(accountRef, updatedData);
            
            dispatch({
                type: Action.ADMIN_UPDATE_B2B_ACCOUNT_SUCCESS,
                payload: { accountId, updatedData },
            });
            
            generatePopup('success', 'B2B account updated successfully');
            resolve({ accountId, updatedData });
        } catch (error: any) {
            dispatch({
                type: Action.ADMIN_UPDATE_B2B_ACCOUNT_FAIL,
                payload: error.message,
            });
            generatePopup('error', 'Failed to update B2B account');
            reject(error);
        }
    });
};

// Send invitation to user for B2B account
export const sendB2BInvitation: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_SEND_INVITATION_INIT,
        })
        
        try {
            const { businessId, email, role, permissions, invitedBy } = payload;
            const baseUrl = `${window.location.protocol}//${window.location.host}`
            
            // Call the backend Cloud Function to send the invitation
            const functions = getFunctions();
            const sendB2BInvitationFunction = httpsCallable(functions, 'sendB2BInvitation');
            
            const result: any = await sendB2BInvitationFunction({
                businessId,
                email,
                role,
                permissions,
                invitedBy,
                baseUrl
            });
            
            dispatch({
                type: Action.ADMIN_SEND_INVITATION_SUCCESS,
                payload: result.data,
            });
            
            // Show appropriate success message based on whether user exists
            if (result.data?.userExists) {
                generatePopup('success', `User ${email} has been automatically added to the business account and notified via email.`);
            } else {
                generatePopup('success', `Invitation sent to ${email}. They will be automatically added to the business account when they register.`);
            }
            
            resolve(result.data);
        } catch (error: any) {
            console.error('Error sending B2B invitation:', error);
            
            let errorMessage = 'Failed to send invitation';
            if (error.code === 'functions/already-exists') {
                errorMessage = 'User already has access to this business account';
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: Action.ADMIN_SEND_INVITATION_FAIL,
                payload: errorMessage,
            });
            generatePopup('error', errorMessage);
            reject(error);
        }
    });
};

// Affiliate management actions
export const getAllAffiliates: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_AFFILIATES_INIT,
        })
        
        try {
            const functions = getFunctions();
            const getAllAffiliatesFunction = httpsCallable(functions, 'getAllAffiliates');
            
            const result: any = await getAllAffiliatesFunction();
            
            if (result.data.result === 'ok') {
                dispatch({
                    type: Action.ADMIN_GET_AFFILIATES_SUCCESS,
                    payload: result.data.affiliates,
                });
                resolve(result.data.affiliates);
            } else {
                throw new Error(result.data.message || 'Failed to get affiliates');
            }
        } catch (error: any) {
            console.error('Error getting affiliates:', error);
            dispatch({
                type: Action.ADMIN_GET_AFFILIATES_FAIL,
                payload: error.message || 'Failed to get affiliates',
            });
            reject(error);
        }
    });
};

export const addAffiliate: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_ADD_AFFILIATE_INIT,
        })
        
        try {
            const { 
                affiliateName, 
                email, 
                offerCode, 
                customPlans, 
                includeStandardPlans, 
                commissionRate, 
                commissionIsPercent 
            } = payload;
            const baseUrl = `${window.location.protocol}//${window.location.host}`;
            
            const functions = getFunctions();
            const addAffiliateFunction = httpsCallable(functions, 'addAffiliate');
            
            const result: any = await addAffiliateFunction({
                affiliateName,
                email,
                offerCode,
                baseUrl,
                customPlans,
                includeStandardPlans,
                commissionRate,
                commissionIsPercent
            });
            
            if (result.data.result === 'ok') {
                dispatch({
                    type: Action.ADMIN_ADD_AFFILIATE_SUCCESS,
                    payload: {
                        affiliateId: result.data.affiliateId,
                        affiliateLink: result.data.affiliateLink
                    },
                });
                
                generatePopup('success', `Affiliate ${affiliateName} created successfully!`);
                resolve({
                    affiliateId: result.data.affiliateId,
                    affiliateLink: result.data.affiliateLink
                });
            } else {
                throw new Error(result.data.message || 'Failed to create affiliate');
            }
        } catch (error: any) {
            console.error('Error adding affiliate:', error);
            
            let errorMessage = 'Failed to create affiliate';
            if (error.code === 'functions/already-exists') {
                errorMessage = 'An affiliate with this email already exists';
            } else if (error.code === 'functions/invalid-argument') {
                errorMessage = error.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: Action.ADMIN_ADD_AFFILIATE_FAIL,
                payload: errorMessage,
            });
            generatePopup('error', errorMessage);
            reject(error);
        }
    });
};

// Custom Plans management actions
export const getAllCustomPlans: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_CUSTOM_PLANS_INIT,
        })
        
        try {
            const functions = getFunctions();
            const getAllCustomPlansFunction = httpsCallable(functions, 'getAllCustomPlans');
            
            const result: any = await getAllCustomPlansFunction();
            
            if (result.data.result === 'ok') {
                dispatch({
                    type: Action.ADMIN_GET_CUSTOM_PLANS_SUCCESS,
                    payload: result.data.plans,
                });
                resolve(result.data.plans);
            } else {
                throw new Error(result.data.message || 'Failed to get custom plans');
            }
        } catch (error: any) {
            console.error('Error getting custom plans:', error);
            dispatch({
                type: Action.ADMIN_GET_CUSTOM_PLANS_FAIL,
                payload: error.message || 'Failed to get custom plans',
            });
            reject(error);
        }
    });
};

export const addCustomPlan: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_ADD_CUSTOM_PLAN_INIT,
        })
        
        try {
            const { planName, planDescription, planFeatures, monthlyPrice, yearlyPrice } = payload;
            
            const functions = getFunctions();
            const addCustomPlanFunction = httpsCallable(functions, 'addCustomPlan');
            
            const result: any = await addCustomPlanFunction({
                planName,
                planDescription,
                planFeatures,
                monthlyPrice,
                yearlyPrice
            });
            
            if (result.data.result === 'ok') {
                dispatch({
                    type: Action.ADMIN_ADD_CUSTOM_PLAN_SUCCESS,
                    payload: {
                        planId: result.data.planId,
                        stripeProductId: result.data.stripeProductId
                    },
                });
                
                generatePopup('success', `Custom plan "${planName}" created successfully!`);
                resolve({
                    planId: result.data.planId,
                    stripeProductId: result.data.stripeProductId
                });
            } else {
                throw new Error(result.data.message || 'Failed to create custom plan');
            }
        } catch (error: any) {
            console.error('Error adding custom plan:', error);
            
            let errorMessage = 'Failed to create custom plan';
            if (error.code === 'functions/already-exists') {
                errorMessage = 'A plan with this name already exists';
            } else if (error.code === 'functions/invalid-argument') {
                errorMessage = error.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: Action.ADMIN_ADD_CUSTOM_PLAN_FAIL,
                payload: errorMessage,
            });
            generatePopup('error', errorMessage);
            reject(error);
        }
    });
};

export const addOfferCode: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_ADD_OFFERCODE_INIT,
        })
        
        try {
            const {
                id,
                max_redemptions,
                allow_in_checkout,
                product_discount,
                product_discount_is_percent,
                subscription_discount,
                subscription_discount_is_percent,
                valid_start,
                valid_end,
                cycles,
                trial_days,
                is_live
            } = payload;
            
            const functions = getFunctions();
            const createOfferCodeFunction = httpsCallable(functions, 'createOfferCode');
            
            const result: any = await createOfferCodeFunction({
                id,
                max_redemptions,
                allow_in_checkout,
                product_discount,
                product_discount_is_percent,
                subscription_discount,
                subscription_discount_is_percent,
                valid_start,
                valid_end,
                cycles,
                trial_days,
                is_live
            });
            
            if (result.data.result === 'ok') {
                dispatch({
                    type: Action.ADMIN_ADD_OFFERCODE_SUCCESS,
                    payload: {
                        offerCodeId: result.data.offerCodeId,
                        stripeCouponId: result.data.stripeCouponId
                    },
                });
                
                generatePopup('success', `Offer code "${id}" created successfully!`);
                resolve({
                    offerCodeId: result.data.offerCodeId,
                    stripeCouponId: result.data.stripeCouponId
                });
            } else {
                throw new Error(result.data.message || 'Failed to create offer code');
            }
        } catch (error: any) {
            console.error('Error adding offer code:', error);
            
            let errorMessage = 'Failed to create offer code';
            if (error.code === 'functions/already-exists') {
                errorMessage = 'An offer code with this ID already exists';
            } else if (error.code === 'functions/invalid-argument') {
                errorMessage = error.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: Action.ADMIN_ADD_OFFERCODE_FAIL,
                payload: errorMessage,
            });
            generatePopup('error', errorMessage);
            reject(error);
        }
    });
};

export const getPlanFeatures: any = () => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        dispatch({
            type: Action.ADMIN_GET_PLAN_FEATURES_INIT,
        })
        
        try {
            const functions = getFunctions();
            const getPlanFeaturesFunction = httpsCallable(functions, 'getPlanFeatures');
            
            const result: any = await getPlanFeaturesFunction();
            
            if (result.data.result === 'ok') {
                dispatch({
                    type: Action.ADMIN_GET_PLAN_FEATURES_SUCCESS,
                    payload: result.data.features,
                });
                resolve(result.data.features);
            } else {
                throw new Error(result.data.message || 'Failed to get plan features');
            }
        } catch (error: any) {
            console.error('Error getting plan features:', error);
            dispatch({
                type: Action.ADMIN_GET_PLAN_FEATURES_FAIL,
                payload: error.message || 'Failed to get plan features',
            });
            reject(error);
        }
    });
};

// Get affiliate data by email (for checking if user is affiliate)
export const getAffiliateByEmail: any = (email: string) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            const functions = getFunctions();
            const getAffiliateByEmailFunction = httpsCallable(functions, 'getAffiliateByEmail');
            
            const result: any = await getAffiliateByEmailFunction({ email });
            
            resolve(result.data);
        } catch (error: any) {
            console.error('Error getting affiliate by email:', error);
            reject(error);
        }
    });
};

// Get standard plans from Stripe
export const getAllStandardPlans: any = () => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            const functions = getFunctions();
            const getAllStandardPlansFunction = httpsCallable(functions, 'getAllStandardPlans');
            
            const result: any = await getAllStandardPlansFunction();
            
            if (result.data.result === 'ok') {
                resolve(result.data.plans);
            } else {
                throw new Error(result.data.message || 'Failed to get standard plans');
            }
        } catch (error: any) {
            console.error('Error getting standard plans:', error);
            reject(error);
        }
    });
};

// Get subscription plans for user (including affiliate plans)
export const getSubscriptionPlansForUser: any = (userEmail: string, affiliateId?: string) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            const functions = getFunctions();
            const getSubscriptionPlansForUserFunction = httpsCallable(functions, 'getSubscriptionPlansForUser');
            
            const result: any = await getSubscriptionPlansForUserFunction({ 
                userEmail, 
                affiliateId 
            });
            
            if (result.data.result === 'ok') {
                resolve({
                    standardPlans: result.data.standardPlans || [],
                    affiliatePlans: result.data.affiliatePlans || [],
                    affiliateData: result.data.affiliateData
                });
            } else {
                throw new Error(result.data.message || 'Failed to get subscription plans');
            }
        } catch (error: any) {
            console.error('Error getting subscription plans for user:', error);
            reject(error);
        }
    });
};

// Track affiliate for upcoming registration
export const trackAffiliateForRegistration: any = (affiliateId: string, userAgent?: string, referrer?: string) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            const functions = getFunctions();
            const trackAffiliateForRegistrationFunction = httpsCallable(functions, 'trackAffiliateForRegistration');
            
            const result: any = await trackAffiliateForRegistrationFunction({ 
                affiliateId, 
                userAgent, 
                referrer 
            });
            
            if (result.data.result === 'ok') {
                resolve(result.data.trackingId);
            } else {
                throw new Error(result.data.message || 'Failed to track affiliate');
            }
        } catch (error: any) {
            console.error('Error tracking affiliate for registration:', error);
            reject(error);
        }
    });
};

// Link affiliate to user after registration
export const linkAffiliateToUser: any = (trackingId: string) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
        try {
            const functions = getFunctions();
            const linkAffiliateToUserFunction = httpsCallable(functions, 'linkAffiliateToUser');
            
            const result: any = await linkAffiliateToUserFunction({ trackingId });
            
            if (result.data.result === 'ok') {
                resolve(result.data.affiliateId);
            } else {
                throw new Error(result.data.message || 'Failed to link affiliate');
            }
        } catch (error: any) {
            console.error('Error linking affiliate to user:', error);
            reject(error);
        }
    });
};